import { Component, ContentChild, Input, TemplateRef } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'ui-master-data-table',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './ui-master-data-table.component.html',
})
export class UiMasterDataTableComponent {
  /** Optional card header title. */
  @Input() title?: string;
  /** Optional subtitle shown below the title. */
  @Input() subtitle?: string;

  /** Show a loading skeleton instead of table content. */
  @Input() loading = false;

  /** Show the empty state instead of table content. */
  @Input() empty = false;
  /** Message shown in the default empty state (ignored when a custom empty-state template is provided). */
  @Input() emptyMessage = 'No items found.';

  /** Number of skeleton rows shown while loading. */
  @Input() skeletonRows = 5;

  /** Optional custom empty-state template injected via <ng-template emptyState>. */
  @ContentChild('emptyState') emptyStateTpl?: TemplateRef<unknown>;

  get skeletonRowsArray(): number[] {
    return Array.from({ length: this.skeletonRows }, (_, i) => i);
  }
}



